import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';

const AchievementUnlock = ({ achievement, onClose }) => {
  useEffect(() => {
    const duration = 3000;
    const end = Date.now() + duration;

    const interval = setInterval(() => {
      if (Date.now() > end) {
        clearInterval(interval);
        return;
      }

      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.6 },
        colors: ['#FFD800', '#00E5FF', '#FF3B30']
      });

      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.6 },
        colors: ['#FFD800', '#00E5FF', '#FF3B30']
      });
    }, 50);

    const timeout = setTimeout(() => {
      onClose();
    }, 4000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [onClose]);

  return (
    <motion.div
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      exit={{ scale: 0, rotate: 180 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
      data-testid="achievement-unlock-modal"
    >
      <motion.div
        animate={{
          scale: [1, 1.05, 1],
          rotate: [0, 5, -5, 0]
        }}
        transition={{
          duration: 0.5,
          repeat: Infinity,
          repeatDelay: 1
        }}
        className="bg-white border-4 border-black rounded-3xl p-8 max-w-md mx-4 shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
          className="inline-block mb-4"
        >
          <Trophy className="w-16 h-16 text-[#FFD800]" strokeWidth={3} />
        </motion.div>

        <h2
          className="text-4xl font-black text-black mb-2 uppercase tracking-tight"
          style={{ fontFamily: 'Bebas Neue, sans-serif' }}
        >
          Achievement Unlocked!
        </h2>

        <div className="text-6xl mb-3">{achievement.icon}</div>

        <h3
          className="text-2xl font-bold text-black mb-2"
          style={{ fontFamily: 'Figtree, sans-serif' }}
        >
          {achievement.title}
        </h3>

        <p
          className="text-black/70 mb-4"
          style={{ fontFamily: 'Figtree, sans-serif' }}
        >
          {achievement.description}
        </p>

        <div className="bg-[#FFD800] border-2 border-black rounded-full px-4 py-2 inline-block">
          <span className="text-black font-black text-lg" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
            +{achievement.xp_bonus} XP
          </span>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default AchievementUnlock;